import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ChartCard, DonutChart } from "@/components/Elements/Charts";
import ListStatisticsCardExtra from "@/components/ListStatistics/ListStatisticsCardExtra";
import {
  useListStatistics,
  useListDonutChartSelected,
} from "@/components/ListStatistics/ListStatisticsHooks";
import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";
import { useTranslateNumber } from "@/modules/translate";

const STATS_DATA_KEY = "condition_ratings";
const FILTER_KEY = "condition_rating";

const AssetsConditionRatingDonutChart = () => {
  const { t } = useTranslation();
  const { translateNumber } = useTranslateNumber();

  const { isLoading: referentialIsLoading, getReferentialAttr } =
    useReferentialConditionRatings();

  const { loading, fetching, statsData } = useListStatistics({
    statsDataKey: STATS_DATA_KEY,
    filterKey: FILTER_KEY,
  });

  const chartData = useMemo(() => {
    return Object.entries(statsData).map(([key, value]) => ({
      name: key,
      value,
      color: getReferentialAttr({ rating: key }, "color"),
    }));
  }, [statsData, getReferentialAttr]);

  const { selectedLegend, onLegendSelectChange } = useListDonutChartSelected({
    filterKey: FILTER_KEY,
    chartData,
  });

  return (
    <ChartCard
      title={t("asset:statistics.conditionRating.title")}
      extra={<ListStatisticsCardExtra filterKey={FILTER_KEY} />}
    >
      <DonutChart
        data={chartData}
        loading={loading || referentialIsLoading}
        fetching={fetching}
        formatName={(name) => getReferentialAttr({ rating: name }, "name")}
        controlled={{ selectedLegend }}
        onLegendSelectChange={onLegendSelectChange}
        formatTooltipValue={translateNumber}
      />
    </ChartCard>
  );
};

export default AssetsConditionRatingDonutChart;
